import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const own = <T>(map: Readonly<Record<string | number, T>>, key: unknown): T | undefined =>
  (typeof key === "string" || typeof key === "number") && Object.prototype.hasOwnProperty.call(map, key)
    ? map[key]
    : undefined;

export function safeGet<T extends Record<string, any>, K extends keyof T>(
  obj: T | null | undefined,
  key: K,
): T[K] | undefined {
  if (obj && key in obj) {
    return obj[key];
  }
  return undefined;
}
